import state from './informacastdialcast.state'
import mutations from './informacastdialcast.mutations'
import actions from './informacastdialcast.actions'

export default {
  state,
  mutations,
  actions
}
